import { t } from '../../../strings/i18n';
import maximumFourDigits from '../../../xform/validators/maximumFourDigits';
export const NICKNAME_INPUT_NAME = 'nickname';
const nicknameConfig = () => [
    NICKNAME_INPUT_NAME,
    undefined,
    'ENABLED',
    [maximumFourDigits(t('errors.invalidNickname'))]
];
export default nicknameConfig;
